// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"655":"58aaad25","988":"a353dca1"}[chunkId] + ".chunk.js";
};